import { apiGet, apiPostJSON } from 'App/Dataman';
import { SOCIAL_MEDIA_SCRAPER_PATHS } from '@/app/api/socialMediaScraper/paths';

const exportJobUrl = (jobId) => `${SOCIAL_MEDIA_SCRAPER_PATHS.coreResultsExport}/${jobId}`;

export function getCoreResults(params = {}) {
  return apiGet(SOCIAL_MEDIA_SCRAPER_PATHS.coreResults, { params });
}

export function getCoreSessions(params = {}) {
  return apiGet(SOCIAL_MEDIA_SCRAPER_PATHS.coreSessions, { params });
}

// The XLSX export is asynchronous: this only enqueues a job, the file is fetched later
// from the `download_url` a completed job carries.
export function createCoreResultsExport(filter = {}) {
  return apiPostJSON(SOCIAL_MEDIA_SCRAPER_PATHS.coreResultsExport, filter);
}

export function getCoreResultsExportJob(jobId) {
  return apiGet(exportJobUrl(jobId));
}

export const coreResults = {
  getList: getCoreResults,
  createExport: createCoreResultsExport,
  getExportJob: getCoreResultsExportJob,
};

export const coreSessions = {
  getList: getCoreSessions,
};

export default {
  coreResults,
  coreSessions,
};
